const headerState = {
  title: null,
  contentId: null,
  tabPosition: 0,
  subTitle: "",
  tabs: null,
  isOpenAccountMenu: false,
  isOpenAccountPopOver: false,
  isOpenAppStack: false,
};

export default headerState;

